import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useNavigate, useLocation } from "react-router-dom";
import ProfileDropDown from "./ProfileDropDown";

const NAV_TABS = [
  { label: "Home",      path: "/municipality/" },
  { label: "ADD",      path: "/municipality/admd/" },
  { label: "M&V",       path: "/municipality/mv" },
  { label: "Installs",  path: "/municipality/installs/" },
  { label: "Reporting", path: "/municipality/reporting/" },
];

export default function MunicipalityNavbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const activeIndex = NAV_TABS.findIndex((t) =>
    t.path === "/municipality/"
      ? location.pathname === "/municipality/"
      : location.pathname.startsWith(t.path)
  );

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        backgroundColor: "#161B22",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
        zIndex: 1400,
      }}
    >
      {/* Brand row */}
      <Toolbar sx={{ gap: "4px", minHeight: "52px !important" }}>
        <Box
          sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          onClick={() => navigate("/municipality/")}
        >
          <img src="/assets/tjommie-logo.svg" height="24" alt="Tjommie" style={{ display: "block" }} />
        </Box>

        <Box sx={{ width: "1px", height: "16px", backgroundColor: "rgba(255,255,255,0.15)", mx: "12px", flexShrink: 0 }} />

        <Typography sx={{ color: "rgba(255,255,255,0.5)", fontSize: "0.88rem", fontWeight: 400, flexGrow: 1 }}>
          Municipality
        </Typography>

        <ProfileDropDown />
      </Toolbar>

      {/* Tab row */}
      <Box sx={{ borderTop: "1px solid rgba(255,255,255,0.05)", pl: "24px" }}>
        <Tabs
          value={activeIndex < 0 ? false : activeIndex}
          onChange={(_, i) => navigate(NAV_TABS[i].path)}
          TabIndicatorProps={{ style: { backgroundColor: "#FDB940", height: "2px" } }}
          sx={{
            minHeight: "40px",
            "& .MuiTab-root": {
              color: "rgba(255,255,255,0.45)",
              fontSize: "0.82rem",
              fontWeight: 500,
              textTransform: "none",
              minWidth: "auto",
              minHeight: "40px",
              px: "16px",
              py: 0,
              "&:hover": { color: "rgba(255,255,255,0.8)" },
            },
            "& .Mui-selected": { color: "#fff !important", fontWeight: 600 },
          }}
        >
          {NAV_TABS.map((t) => (
            <Tab key={t.path} label={t.label} disableRipple />
          ))}
        </Tabs>
      </Box>
    </AppBar>
  );
}
